/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import {
  Modal,
  Button,
  Box,
  CircularProgress,
  TextField,
  Card,
  CardContent,
  CardActions,
  CardHeader,
  IconButton,
  InputAdornment
} from '@mui/material';
import { Close, ManageAccountsOutlined } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { ValidateRole } from '../../assets/validation';
import RolePermAction from '../../store/actions/RolePermAction';

function RoleAdd({ openmodal, onCloseModal }) {
  /* Modal Style */

  const dispatch = useDispatch();

  return (
    <Modal
      className="cmn__form__modal"
      open={openmodal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box>
        <Formik
          initialValues={{
            name: ''
          }}
          // enableReinitialize
          validationSchema={ValidateRole}
          onSubmit={(values, { setErrors, setSubmitting }) => {
            dispatch(RolePermAction.add(values, setErrors, setSubmitting, onCloseModal));
          }}
        >
          {({
            errors,
            touched,
            values,
            handleChange,
            handleBlur,
            handleSubmit,
            handleReset,
            isSubmitting
          }) => (
            <form onSubmit={handleSubmit}>
              <Card>
                <CardHeader
                  title="Add Role"
                  action={
                    <IconButton
                      aria-label="settings"
                      onClick={() => {
                        onCloseModal();
                      }}
                    >
                      <Close />
                    </IconButton>
                  }
                />
                <CardContent>
                  <TextField
                    id="name"
                    fullWidth
                    label="Role Name"
                    name="name"
                    margin="normal"
                    placeholder="Enter Role Name"
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.name && touched.name}
                    helperText={errors.name && touched.name && errors.name}
                    required={false}
                    InputLabelProps={{ required: true }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">
                          <IconButton
                            aria-label="toggle password visibility"
                            edge="end"
                            disabled
                            // color="secondary"
                          >
                            <ManageAccountsOutlined sx={{ color: '#fff' }} />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                </CardContent>
                <CardActions sx={{ justifyContent: 'center' }}>
                  <Button
                    type="submit"
                    className="save__btn"
                    variant="contained"
                    color="secondary"
                    // fullWidth
                    disabled={isSubmitting}
                    size="medium"
                  >
                    {isSubmitting ? <CircularProgress size={20} /> : 'Submit'}
                  </Button>
                  <Button
                    type="button"
                    className="cancel__btn"
                    variant="contained"
                    color="info"
                    size="medium"
                    onClick={() => {
                      handleReset();
                    }}
                  >
                    Clear
                  </Button>
                </CardActions>
              </Card>
            </form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
}
RoleAdd.propTypes = {
  openmodal: PropTypes.string.isRequired,
  onCloseModal: PropTypes.func.isRequired
};

export default RoleAdd;
